import * as React from 'react'
import {Button} from 'react-bootstrap'

type ButtonType = 'button' | 'submit'

interface ButtonBarProps {
  onBack: () => void
  onContinue: () => void
  backDisabled?: boolean
  continueDisabled?: boolean
  continueId?: string
  continueType?: ButtonType
  backText?: string
  continueText?: string
  barClassName?: string
  hidden?: boolean
}

const ButtonBar: React.FC<ButtonBarProps> = ({
                                               onBack,
                                               onContinue,
                                               backDisabled = false,
                                               continueDisabled = false,
                                               continueId = 'continue',
                                               continueType = 'button',
                                               backText = 'BACK',
                                               continueText = 'CONTINUE',
                                               barClassName = '',
                                               hidden = false,
                                             }) => {
  if (hidden) return null

  return (
    <div className={`btn-bar${barClassName ? ` ${barClassName}` : ''}`}>
      <Button
        id={continueId}
        type={continueType}
        bsSize="lg"
        className="pull-right continue-button green-back"
        disabled={continueDisabled}
        onClick={onContinue}
      >
        {continueText}
      </Button>

      <Button
        bsSize="lg"
        className="back-button blue-back"
        disabled={backDisabled}
        onClick={onBack}
      >
        {backText}
      </Button>
    </div>
  )
}

export default ButtonBar
